// extracted by mini-css-extract-plugin
module.exports = {"copyright":"CopyRight_SA_copyright__2RA3S","backGround":"CopyRight_SA_backGround__1nmfM","height":"CopyRight_SA_height__2quDh"};